import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, finalize, throwError } from 'rxjs';
import { AppService } from '../services/app.service';
import { SessionStorageService } from '../services/session-storage.service'; 
import { environment } from 'src/environments/environment'; 
import { DmsProblemDetails } from '../services/client.service';

let activeRequests = 0;

export const authInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const appService = inject(AppService);
  const sessionStorageService = inject(SessionStorageService);

  const excludedUrls: string[] = ["ChecklistReport"];
  const shouldExclude = excludedUrls.some(url => request.url.includes(url));

  if (!shouldExclude) {
    activeRequests++;
    appService.setLoading(true);
  }

  const sessionToken = sessionStorageService.getSessionItem('oab-profile');

  let headers = request.headers
    .set('Content-Type', 'application/json')
    .set('API-Key', environment.apiKey);

  if (sessionToken) {
    headers = headers.set('Authorization', `Bearer ${sessionToken}`);
  }

  const clonedRequest = request.clone({ headers });

  return next(clonedRequest).pipe(
    finalize(() => {
      if (!shouldExclude) {
        activeRequests--;
        if (activeRequests === 0) {
          appService.setLoading(false);
        }
      }
    }),
    catchError((err: any) => {
      if (err.error) {
        getProblemDetails(err).subscribe(
          problemDetails => appService.handleErrorMessage(problemDetails.detail),
          () => appService.handleErrorMessage(err.detail)
        );
      } else {
        appService.handleErrorMessage(err.error?.detail);
      }
      return throwError(() => err);
    })
  );
};

function getProblemDetails(err: HttpErrorResponse): Observable<DmsProblemDetails> {
  return new Observable<DmsProblemDetails>(observer => {
    if (!err.error) {
      observer.error(err);
      observer.complete();
      return;
    }
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const problemDetails = JSON.parse((event.target as any).result);
        observer.next(problemDetails);
      } catch {
        observer.error(err);
      } finally {
        observer.complete();
        return;
      }
    };
    reader.readAsText(err.error);
  });
}
